import type { DataLayerPayload } from './Types'

import TrackingOptOutService from '../Service/TrackingOptOutService'

// Matomo runs cookieless for every visitor, so there is no consent gate here. `_mtm` is a queue
// the container drains in full once it loads, which means a push that happens before the
// container exists still arrives — no buffering needed on our side.
export const push = (payload: DataLayerPayload): void => {
  if (TrackingOptOutService.isOptedOut()) {
    return
  }

  window._mtm = window._mtm ?? []
  window._mtm.push(payload)
}
